import React, { useState } from "react";

function RateRestaurant(props) {
  const { restaurantId } = props;
  console.log(restaurantId);
  const [selectRating, setSelectRating] = useState("");
  const handleSelectRatingChange = async (event) => {
    setSelectRating(event.target.value);
    console.log(event.target.value);
    console.log(restaurantId);
    await fetch("https://femez.onrender.com/API/restaurant/addUpdateRates", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        restaurantId: restaurantId,
        rating: event.target.value,
      }),
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          console.log("Rate added successfully");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <div>Rate the Restaurant</div>
      <select
        id="restaurantSelector"
        value={selectRating}
        onChange={handleSelectRatingChange}
      >
        <option value="">Rating</option>

        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
    </div>
  );
}
export default RateRestaurant;
